'use strict';

const GUTTER_SIZE = 8;
const MIN_COLUMN_COUNT = 2;
const COLUMN_WIDTH = 224;

const saGrid = [
  '$window',
  '$timeout',

  function ($window, $timeout) {
    return {
      restrict: 'A',
      link: function ($scope, $element, $attr) {
        var parentEl = $element.parent()[0];
        var windowEl = angular.element($window);
        var columnWidth = Number($attr.columnWidth) || COLUMN_WIDTH;
        var minColumnCount = Number($attr.minColumnCount) || MIN_COLUMN_COUNT;
        var gutterSize = Number($attr.gutterSize) || GUTTER_SIZE;

        function setElementWidth() {
          var parentStyles = getComputedStyle(parentEl, null);
          var parentWidth = parentEl.clientWidth - parseFloat(parentStyles.getPropertyValue('padding-left')) - parseFloat(parentStyles.getPropertyValue('padding-right'));
          var columnCount = Math.floor((parentWidth + gutterSize) / (columnWidth + gutterSize));

          if (parentWidth < minColumnCount * columnWidth  || columnCount < minColumnCount) {
            $element.css('width', '100%');
          } else {
            $element.css('width',  String(columnCount * columnWidth + (columnCount - 1) * gutterSize) + 'px');

          }
        }

        $element.css('width', '0px');

        $timeout(setElementWidth);

        windowEl.on('resize', setElementWidth);

        $element.on('$destroy', function () {
          windowEl.off('resize', setElementWidth);
        });
      }
    };
  }
];

export default saGrid;



// WEBPACK FOOTER //
// ./app/src/directives/grid.js